import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import {
  fieldsToGqlString,
  mergeByIdNewAtTop,
} from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const defaultInvestmentFields = {
  _id: '',
  investmentId: '',
  purchaseDate: '',
  maturityDate: '',
  type: '',
  investmentNumber: '',
  interestRate: '',
  groupCode: '',
  isClosed: '',
  isHidden: '',
  bank: {
    _id: '',
    accountNumber: '',
    altKeyBase: '',
    bankCode: '',
    bankName: '',
    groupCode: '',
    routingNumber: '',
    bankAddress: '',
  },
  fund: {
    _id: '',
    fund: '',
    fiscalYear: '',
    description: '',
    altKey: '',
  },
};

const defaultInvestmentDetailsFields = {
  _id: '',
  investmentId: '',
  purchaseDate: '',
  maturityDate: '',
  type: '',
  investmentNumber: '',
  interestRate: '',
  groupCode: '',
  isClosed: '',
  isHidden: '',
  bank: {
    _id: '',
    accountNumber: '',
    altKeyBase: '',
    bankCode: '',
    bankName: '',
    groupCode: '',
    routingNumber: '',
    bankAddress: '',
  },
  fund: {
    _id: '',
    fund: '',
    fiscalYear: '',
    description: '',
    altKey: '',
  },
  details: {
    _id: '',
    date: '',
    entryType: '',
    amount: '',
    description: '',
    isReceipt: '',
    isMisReceipt: '',
  },
};

export const glInvestmentTransaction = {
  namespaced: true,
  state: () => ({
    regYears: {},
    nextInvestmentNumber: undefined,
    investmentPolling: undefined,
    selectedItems: [],
    receiptPulse: false,
  }),
  mutations: {
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setFiscalRegYears(state, regYears) {
      state.regYears = regYears;
    },
    setReceiptPulse(state, shouldPulse) {
      state.receiptPulse = shouldPulse;
    },
    setStats(state, results) {
      if (results.glStatsMaxInvestmentNumber
        && results.glStatsMaxInvestmentNumber.max !== undefined) {
        const nextInvestmentNumber = results.glStatsMaxInvestmentNumber.max + 1;
        if (state.nextInvestmentNumber !== nextInvestmentNumber) {
          state.nextInvestmentNumber = nextInvestmentNumber;
        }
      }
    },
    setinvestmentPolling(state, timer) {
      if (state.investmentPolling) {
        clearInterval(state.investmentPolling);
      }
      state.investmentPolling = timer;
    },
  },
  actions: {
    async loadInvestmentTrans({ commit, dispatch }, {
      criteria, fields, baseCrudKey,
    }) {
      let results;
      const gqlfields = fields || defaultInvestmentFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query glInvestmentHeaderInfo($criteria: glInvestmentHeaderInfoTranCriteriaType) {
            glInvestmentHeaderInfo(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',

        });
        clients.handleGQLErrors(results, commit);
        const investmentTrans = results.data ? results.data.glInvestmentHeaderInfo || [] : [];
        commit('base/crud/setItems', [baseCrudKey, investmentTrans], { root: true });
        return investmentTrans;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem loading the Transaction List!', { root: true });
      }
      return [];
    },
    async loadInvestmentDetailsTrans({ commit, dispatch }, {
      criteria, fields, baseCrudKey, postProcessTrans,
    }) {
      let results;
      const gqlfields = fields || defaultInvestmentDetailsFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query glInvestmentDetailsInfo($criteria: glInvestmentDetailsInfoTranCriteriaType) {
            glInvestmentDetailsInfo(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',

        });
        clients.handleGQLErrors(results, commit);
        if (baseCrudKey && results.data && results.data.glInvestmentDetailsInfo) {
          const investmentTrans = postProcessTrans
            ? postProcessTrans(results.data.glInvestmentDetailsInfo)
            || [] : results.data.glInvestmentDetailsInfo;
          commit('base/crud/setItems', [baseCrudKey, investmentTrans], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem loading the Transaction List!', { root: true });
      }
      return [];
    },
    async upsertInvestmentTrans({ dispatch, rootGetters, commit }, { item, baseCrudKey, fields }) {
      let results;
      try {
        const gqlfields = fields || defaultInvestmentFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertGlInvestmentHeaderInfo ($item: glInvestmentHeaderInfoTransInputType!)  {
            upsertGlInvestmentHeaderInfo(upsert: $item) {
              ${fieldsToGqlString(gqlfields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const investmentStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newInvestment = results.data.upsertGlInvestmentHeaderInfo;
        const newList = mergeByIdNewAtTop(investmentStateData || [], newInvestment);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        return newInvestment;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the investment', { root: true });
      }
      return null;
    },

    async upsertInvestDetailsTransaction({ dispatch, rootGetters, commit },
      { item, baseCrudKey, fields }) {
      let results;
      try {
        const gqlfields = fields || defaultInvestmentDetailsFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation updateGlInvestmentDetails ($item: investDetailsInputType!)  {
            updateGlInvestmentDetails(upsert: $item) {
              ${fieldsToGqlString(gqlfields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const investmentStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newInvestment = results.data.updateGlInvestmentDetails;
        const newList = mergeByIdNewAtTop(investmentStateData || [], newInvestment);
        commit('base/crud/setItems', ['investmentDetails', newList], { root: true });
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        const details = newInvestment.details.filter(Boolean);
        // eslint-disable-next-line no-param-reassign
        details.forEach((d, i) => { d.index = i; });
        commit('base/crud/setItems', ['investmentBelow', details], { root: true });
      } catch (e) {
        console.info(' log exception ', e.message);
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the investment', { root: true });
      }
    },

    async deleteDetailsTrans({ commit, dispatch, rootGetters },
      { item, baseCrudKey, baseCrudKeyBelow }) {
      let results;
      try {
        const gqlfields = defaultInvestmentDetailsFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`
        mutation deleteGlInvestmentDetail($id: ID!, $index: Int!) {
          deleteGlInvestmentDetail(id: $id, index: $index) {
            ${fieldsToGqlString(gqlfields)},
          }
        }
      `,
          variables: {
            id: item._id,
            index: item.index,
          },
        });

        clients.handleGQLErrors(results, commit);
        const updatedData = { ...results.data.deleteGlInvestmentDetail };
        const investmentDetailsStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newList = mergeByIdNewAtTop(investmentDetailsStateData || [], updatedData);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        const details = updatedData.details.filter(Boolean);
        // eslint-disable-next-line no-param-reassign
        details.forEach((d, i) => { d.index = i; });
        commit('base/crud/setItems', [baseCrudKeyBelow, details], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the transaction!', { root: true });
      }
    },

    async delinvestmentTran({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteInvestmentHeaderTran ($id: ID!)  {
            deleteInvestmentHeaderTran(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deleteInvestmentHeaderTran._id;
        const investmentTransData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = investmentTransData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
        dispatch('flashSuccess', 'Investment header info got deleted Successfully!', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the Transaction', { root: true });
      }
    },

    async loadLastInvestmentNo({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query glStatsMaxInvestmentNumber {
            glStatsMaxInvestmentNumber { max }
          }`,
          variables: {},
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        commit('setStats', results.data);
        return results.data.glStatsMaxInvestmentNumber.max;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem determining the last receipt number!', { root: true });
      }
      return null;
    },
  },
};
export default glInvestmentTransaction;
